// extracted by mini-css-extract-plugin
var _1 = "ra-collection-banner-bottom";
var _2 = "ra-collection-banner";
var _3 = "ra-collection-banner-title";
var _4 = "ra-collection-banner-top";
var _5 = "ra-collection-info";
export { _1 as "collectionBannerBottomCls", _2 as "collectionBannerCls", _3 as "collectionBannerTitleCls", _4 as "collectionBannerTopCls", _5 as "collectionInfoCls" }
